import { render, staticRenderFns } from "./GroupNews.vue?vue&type=template&id=be244e6c&scoped=true"
import script from "./GroupNews.vue?vue&type=script&lang=js"
export * from "./GroupNews.vue?vue&type=script&lang=js"
import style0 from "./GroupNews.vue?vue&type=style&index=0&id=be244e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be244e6c",
  null
  
)

export default component.exports